import React from 'react'
import { Link, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";
import { toast } from "react-toastify";


import EnableDisableButton from "components/Shared/EnableDisableButton";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import ShipmentFulfillmentDocumentBasicDetail from "./ShipmentFulfillmentDocumentComponents/ShipmentFulfillmentDocumentBasicDetail";

import {
  useGetShipmentFDDetailQuery,
  useUpdateShipmentFDMutation
} from "store/services/shipmentFulfillmentDocumentApi";
import {
  ShipmentFulfillmentDocumentDetailContext,
  useShipmentFulfillmentDocumentDetailContext
} from "contexts/ShipmentFulfillmentDocumentDetailContext";

const ShipmentFulfillmentDocumentDetailScreen = () => {

  const { id } = useParams();

  const breadcrumb = [
    { title: "Shipment Document", path: "/app/crm/collection-document/list" },
    { title: "Shipment Document Detail" }
  ]

  // RTK Query
  const { data: shipmentFDDetail, isLoading: loadingShipmentFD, error, }
    = useGetShipmentFDDetailQuery(id);

  return (
    <ShipmentFulfillmentDocumentDetailContext.Provider value={{ shipmentFDDetail, loadingShipmentFD }} >
      <BreadcrumbLayout breadcrumbs={breadcrumb}
        isBusy={loadingShipmentFD}
        headerActions={<PageActions />} >

        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <ShipmentFulfillmentDocumentBasicDetail />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </ShipmentFulfillmentDocumentDetailContext.Provider>
  )
}

export default ShipmentFulfillmentDocumentDetailScreen;

const PageActions = () => {

  const { shipmentFDDetail, loadingShipmentFDDetail } = useShipmentFulfillmentDocumentDetailContext();

  // RTK Query
  const [updateShipmentFDDetail, { isLoading: updatingShipmentFDDetail }] = useUpdateShipmentFDMutation();

  // methods
  const handelToggleUpdateShipmentFDStatus = async () => {
    try {
      await updateShipmentFDDetail({
        _id: shipmentFDDetail._id,
        isActive: !shipmentFDDetail.isActive,
      }).unwrap();
      toast.info(`Shipment Document ${shipmentFDDetail.isActive ? "Disable" : "Enable"} !`);
    } catch (error) {
      toast.error(error?.data?.message ?? "Could Not Update Status");
    }
  }

  return (
    <div className="flex space-x-4">
      <EnableDisableButton
        isActive={shipmentFDDetail?.isActive}
        loading={loadingShipmentFDDetail || updatingShipmentFDDetail}
        onClick={handelToggleUpdateShipmentFDStatus}
      />
      <Link to={`/app/crm/collection-document/${shipmentFDDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};